export const ORIGIN_BACKEND_HEADER = 'X-API-Origin-Backend';
